import {BaseOverlayProps, MapContext, MapService} from "../data-map-props";
import React from "react";

export class LabelOverlay extends React.Component<BaseOverlayProps> {

    static contextType = MapContext;

    public context: MapService | undefined;

    static defaultProps: BaseOverlayProps = {
        overlayPosition: "over-map"
    };

    public render() {

        if (!this.context) return "";
        const context: MapService = this.context;

        if (!context.tree) return "";
        const groups = context.tree.groupSites([...context.data.values.keys()], 120, 'miles');

        const unitConverter: (number) => number = (context.displayUnitSystem === context.dataUnitSystem || !context.data.metric.unit.supports(context.displayUnitSystem))
            ? n => n
            : n => context.data.metric.unit.convert(n, context.dataUnitSystem, context.displayUnitSystem);

        return [...groups.keys()].map((site, index) => {
            const coords = context.projection(site.position);
            if (coords) {
                const [x, y] = coords;
                return (
                    <text key={index} textAnchor="middle" x={x} y={y}>
                        {
                            context.formatter(unitConverter(context.data.values.get(site)))
                        }
                    </text>
                );
            }
        })

    }

}